<template>
  <b-tab title="Sessions" lazy class="tab__session">
    <!-- Tab title name -->
    <div slot="title">
      <span class="font-size-md active span__sessions-tab">Learning</span>
      <div class="divider" />
    </div>
    <div class="d-flex justify-content-between mb-1">
      <!-- Header -->
      <div class="d-flex flex-column align-items-start">
        <h5 class="font-weight-bold font-size-lg">Learning</h5>
      </div>

      <!-- Button create section -->
      <!-- <b-button
        ref="b--create-session"
        class="button__create-a-session mr-3"
        :disabled="
          isSectionLimited || learningUnit.is_published === false || disabled
        "
        variant="first"
        @click="goToCreateSectionPage()"
      >
        <span>Create a session</span>
      </b-button> -->

      <b-button
        v-if="showManageButton"
        variant="outline-primary"
        class="button__view-manage"
        @click="goToFeedPage()"
        v-text="goToFeedButtonText"
      >
      </b-button>
    </div>

    <div class="text-dark mr-auto">
      You can click to view learning feed and participated in community.
    </div>

    <b-alert :show="isSectionLimited" variant="info" class="mx-3">
      Cannot create more than 4 sessions
    </b-alert>

    <!-- <transition-group name="list" tag="div">
      <div v-for="(section, index) in sections" :key="section.id" class="mt-4">
        <ListSession
          v-if="section"
          :number-of-online-meeting="learningUnit.number_of_online_meeting"
          :section="section"
          :learning-unit="learningUnit"
          :conflict="conflict && conflict[section.id] ? conflict[section.id].conflict : false"
          :index="index"
          :disabled="disabled"
          :editable="!disabled"
          :show-manage-button="$currentUser.canAccessLearn(section.learning_unit_id)"
          :feed-route="{
            name:
              mode === 'instructor'
                ? 'design-planning/teaching-feed'
                : 'review-learning-unit/teaching-feed',
            params: {
              sectionId: section.id,
              learningUnitId: section.learning_unit_id
            }
          }"
        />

        <div class="divider my-4" />
      </div>
    </transition-group> -->

    <div v-if="!sections.length" class="text-dark mt-4">No Session</div>
  </b-tab>
</template>

<script>
import Section from '@/models/Section';
// import LearningUnit from "@/models/LearningUnit";
// import ListSession from './components/ListSession';

export default {
  components: {
    // ListSession
  },

  props: {
    learningUnit: {
      type: Object,
      default: () => {}
    },

    mode: {
      type: String,
      default: 'instructor'
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    }
  },

  // watch: {
  //   "learningUnit.id": {
  //     immediate: true,
  //     handler: "fetchCheckConflict",
  //   },
  // },

  data() {
    return {
      conflict: {}
    };
  },

  computed: {
    sections() {
      return Section.query()
        .where('learning_unit_id', this.learningUnit.id)
        .orderBy('start_at', 'asc')
        .get();
    },

    defaultSection() {
      return this.sections ? this.sections.find((section) => section.is_default) : null;
    },

    /**
     * sections equal to 4 then can't create more sections
     * @return {Boolean} true: disabled create section button & show warning
     */
    isSectionLimited() {
      return this.sections.length === 4;
    },

    showManageButton() {
      return this.defaultSection
        ? this.$currentUser.canAccessLearn(this.defaultSection.learning_unit_id)
        : false;
    },

    goToFeedButtonText() {
      return this.$currentUser.canEditLearn(this.learningUnit.id) ? 'View / Manage' : 'View Post';
    }
  },

  // async mounted() {
  //   await this.init();
  // },

  methods: {
    // async fetchCheckConflict(learningUnitId) {
    //   if (!learningUnitId) return;

    //   try {
    //     this.conflict =
    //       await LearningUnit.api().getConflictBetweenSectionAndPost(
    //         learningUnitId
    //       );
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },

    goToCreateSectionPage() {
      this.$router.push({
        name: 'design-planning/section/create',
        params: {
          learningUnitId: this.learningUnit.id,
          // sectionId: null,
          pageType: 'create'
        },
        query: {
          previousPath: this.$route.fullPath
        }
      });
    },

    goToFeedPage() {
      this.$router.push({
        name:
          this.mode === 'reviewer'
            ? 'review-learning-unit/teaching-feed'
            : 'design-planning/teaching-feed',
        params: {
          sectionId: this.defaultSection.id,
          learningUnitId: this.defaultSection.learning_unit_id
        },
        query: {
          previousPath: this.$route.fullPath,
          view: 'feed',
          tab: 'posts'
        }
      });
    }
  }
};
</script>

<style lang="scss">
.tab__session {
  .button__create-a-session {
    width: 160px !important;
    height: 40px !important;
    padding: 0 0;
  }

  .container__session-row {
    width: 100%;
  }
}
</style>
